export const mockData = {
  header: {
    name: "Ahmad Faqih Abqory",
    title: "Fullstack Web Developer",
    location: "Bogor, Indonesia",
    profileImage: "/assets/images/profile/abqory.png",
    social: {
      instagram: "https://www.instagram.com/ahfary_",
      github: "https://github.com/ahfary",
      linkedin: "https://www.linkedin.com/in/faqih-abqory/",
    },
  },
  about: {
    description:
      "Siswa tingkat akhir yang sedang menempuh pendidikan di SMK jurusan Rekayasa Perangkat Lunak (RPL). Memiliki ketertarikan mendalam pada pengembangan website, khususnya Fullstack Web Development. Terbiasa bekerja dengan tim, memiliki kemampuan analisis yang baik, serta semangat belajar yang tinggi.",
  },
  homeProjects: [
    {
      id: "sakusantri",
      title: "SakuSantri Dashboard",
      description:
        "SakuSantri adalah sistem manajemen keuangan digital yang dirancang khusus untuk lingkungan pondok pesantren. Aplikasi ini mengubah sistem jajan dan pengelolaan uang saku santri dari metode konvensional menjadi sistem non-tunai (cashless) berbasis saldo, yang dapat dikelola oleh admin dan dipantau oleh orang tua/wali santri (walsan).",
      technologies: ["Next.js", "TypeScript", "TailwindCSS", "Nest.js"],
      siteUrl: "https://sakusantri.ahmadfaqihabqory.my.id/",
      image: "/assets/images/projects/sakusantri/saku.png",
    },
    {
      id: "eco-heroes",
      title: "Echo Heroes",
      description:
        "Eco Heroes adalah game edukatif berbasis website yang dirancang untuk meningkatkan kesadaran tentang pentingnya menjaga kebersihan lingkungan dengan cara yang interaktif dan menyenangkan. Pemain berperan sebagai pahlawan yang bertugas membersihkan dunia dari sampah sekaligus melawan makhluk jorok (goblin, ogre, dan orc) yang terkontaminasi virus akibat lingkungan yang kotor.",
      technologies: ["HTML", "CSS", "JavaScript"],
      image: "/assets/images/projects/ecoheroes/eco.avif",
      siteUrl: "https://ecoheroes.ahmadfaqihabqory.my.id/",
    },
    {
      id: "ppdb-system",
      title: "PPDB System",
      description:
        "PPDB Online adalah aplikasi berbasis website yang dirancang untuk mempermudah proses Penerimaan Peserta Didik Baru (PPDB) di sekolah. Proyek ini dibangun untuk mensimulasikan alur pendaftaran siswa secara digital, mulai dari input data diri hingga verifikasi oleh admin.",
      technologies: ["Next.js", "TypeScript", "TailwindCSS", "Firebase"],
      image: "/assets/images/projects/ppdb/ppdb.avif",
    },
    {
      id: "lepshop",
      title: "Lepshop E - Commerce",
      description:
        "Lepshop adalah aplikasi berbasis website yang dirancang untuk mensimulasikan sistem e-commerce sederhana. Proyek ini dibuat sebagai latihan pengembangan aplikasi web dengan fokus pada manajemen data produk dan sistem login berbasis peran.",
      technologies: ["React", "TailwindCSS", "JavaScript"],
      image: "/assets/images/projects/lepshop/lepshop.avif",
    },
  ],
  allProjects: [
    {
      id: "learning-path",
      title: "Abqory Learning Path",
      description:
        "Abqory Learning Path adalah website dokumentasi pembelajaran yang komprehensif untuk pengembang web pemula. Dibangun menggunakan Docusaurus, platform ini menyediakan jalur belajar terstruktur mencakup HTML, CSS, dan JavaScript, lengkap dengan materi yang mudah dipahami dan dokumentasi yang rapi.",
      technologies: ["Docusaurus", "React", "Markdown"],
      image: "/assets/images/projects/learningpath/learn2.png", // Pastikan Anda membuat folder dan upload gambar ini
      siteUrl: "https://learningpath.ahmadfaqihabqory.my.id/", // Sesuaikan dengan subdomain yang Anda rencanakan
      gallery: [
        "/assets/images/projects/learningpath/learn1.png",
        "/assets/images/projects/learningpath/learn2.png",
      ],
    },
    {
      id: "eco-heroes",
      title: "Echo Heroes",
      description:
        "Eco Heroes adalah game edukatif berbasis website yang dirancang untuk meningkatkan kesadaran tentang pentingnya menjaga kebersihan lingkungan dengan cara yang interaktif dan menyenangkan. Pemain berperan sebagai pahlawan yang bertugas membersihkan dunia dari sampah sekaligus melawan makhluk jorok (goblin, ogre, dan orc) yang terkontaminasi virus akibat lingkungan yang kotor.",
      technologies: ["HTML", "CSS", "JavaScript"],
      image: "/assets/images/projects/ecoheroes/eco.avif",
      siteUrl: "https://ecoheroes.ahmadfaqihabqory.my.id/",
      gallery: [
        "/assets/images/projects/ecoheroes/eco1.avif",
        "/assets/images/projects/ecoheroes/eco2.avif",
        "/assets/images/projects/ecoheroes/eco3.png",
      ],
    },
    {
      id: "cv",
      title: "CV Website",
      description:
        "Website CV adalah proyek berbasis web yang menampilkan informasi pribadi, pendidikan, keterampilan, sertifikasi, dan pengalaman dalam bentuk portofolio digital interaktif. Proyek ini bertujuan untuk memberikan alternatif modern dari CV tradisional dengan desain yang lebih menarik dan mudah diakses.",
      technologies: ["HTML", "CSS", "JavaScript"],
      image: "/assets/images/projects/cv/cv.avif",
      siteUrl: "https://cv.ahmadfaqihabqory.my.id/",
      gallery: [
        "/assets/images/projects/cv/cv1.webp",
        "/assets/images/projects/cv/cv2.webp",
      ],
    },
    {
      id: "sakusantri",
      title: "SakuSantri Dashboard",
      description:
        "SakuSantri adalah sistem manajemen keuangan digital yang dirancang khusus untuk lingkungan pondok pesantren. Aplikasi ini mengubah sistem jajan dan pengelolaan uang saku santri dari metode konvensional menjadi sistem non-tunai (cashless) berbasis saldo, yang dapat dikelola oleh admin dan dipantau oleh orang tua/wali santri (walsan).",
      technologies: ["Next.js", "TypeScript", "TailwindCSS", "Nest.js"],
      image: "/assets/images/projects/sakusantri/saku.png",
      siteUrl: "https://sakusantri.ahmadfaqihabqory.my.id/",
      gallery: [
        "/assets/images/projects/sakusantri/saku1.png",
        "/assets/images/projects/sakusantri/saku2.png",
        "/assets/images/projects/sakusantri/saku3.png",
      ],
    },
    {
      id: "lepshop",
      title: "Lepshop E - Commerce",
      description:
        "Lepshop adalah aplikasi berbasis website yang dirancang untuk mensimulasikan sistem e-commerce sederhana. Proyek ini dibuat sebagai latihan pengembangan aplikasi web dengan fokus pada manajemen data produk dan sistem login berbasis peran.",
      technologies: ["React", "TailwindCSS", "JavaScript"],
      image: "/assets/images/projects/lepshop/lepshop.avif",
      gallery: [
        "/assets/images/projects/lepshop/lepshop1.webp",
        "/assets/images/projects/lepshop/lepshop2.webp",
      ],
    },
    {
      id: "ppdb-system",
      title: "PPDB System",
      description:
        "PPDB Online adalah aplikasi berbasis website yang dirancang untuk mempermudah proses Penerimaan Peserta Didik Baru (PPDB) di sekolah. Proyek ini dibangun untuk mensimulasikan alur pendaftaran siswa secara digital, mulai dari input data diri hingga verifikasi oleh admin.",
      technologies: ["Next.js", "TypeScript", "TailwindCSS", "Firebase"],
      image: "/assets/images/projects/ppdb/ppdb.avif",
      gallery: [
        "/assets/images/projects/ppdb/ppdb1.webp",
        "/assets/images/projects/ppdb/ppdb2.webp",
      ],
    },
  ],
  experience: [
    {
      role: "Business Development & Media Intern",
      organization: "NRA Group Travel",
      location: "Jakarta Selatan, Indonesia",
      date: "2026 – Sekarang",
      points: [
        "Mendukung strategi pengembangan bisnis dan kemitraan untuk paket perjalanan Umrah & Haji.",
        "Mengelola konten kreatif dan media sosial perusahaan untuk meningkatkan brand awareness dan engagement.",
        "Melakukan riset pasar dan analisis kompetitor guna mengoptimalkan layanan dan produk travel.",
      ],
    },
    {
      role: "Sekertaris OSIS Masa Bakti 2024 - 2025",
      organization: "SMK MADINATULQURAN",
      location: "Jonggol, Indonesia",
      date: "2024 – 2025",
      points: [
        "Mengelola dokumentasi administrasi OSIS, termasuk pencatatan notulen rapat dan arsip kegiatan.",
        "Menyusun jadwal kegiatan serta memastikan koordinasi antara anggota OSIS dan pihak sekolah.",
        "Membuat serta mendistribusikan materi publikasi acara OSIS untuk meningkatkan keterlibatan siswa.",
      ],
    },
    {
      role: "Sekertaris OSIS Masa Bakti 2022 - 2023",
      organization: "SMPIT AL - HIDAYAH Boarding School",
      location: "Bogor, Indonesia",
      date: "2022 – 2023",
      points: [
        "Bertanggung jawab dalam mendukung kepemimpinan OSIS melalui pengelolaan administrasi dan komunikasi.",
        "Mengatur jadwal pertemuan serta mencatat hasil rapat untuk memastikan kelancaran kegiatan.",
        "Membuat spanduk dan materi publikasi acara OSIS untuk meningkatkan partisipasi siswa.",
      ],
    },
    {
      role: "Anggota PAMUDA Masa Bakti 2022 - 2023",
      organization: "SMPIT AL - HIDAYAH Boarding School",
      location: "Bogor, Indonesia",
      date: "2022 – 2023",
      points: [
        "Berpartisipasi aktif dalam kegiatan outdoor seperti kemah dan pelatihan bertahan hidup.",
        "Mengikuti program pengembangan diri yang menantang untuk memperluas wawasan dan keterampilan.",
        "Terlibat dalam proyek sosial yang berkontribusi positif bagi lingkungan sekitar.",
      ],
    },
    {
      role: "Designer Aktif 2022 - 2023",
      organization: "SMPIT AL - HIDAYAH Boarding School",
      location: "Bogor, Indonesia",
      date: "2022 – 2023",
      points: [
        "Membuat berbagai desain kreatif untuk keperluan acara dan kegiatan sekolah.",
        "Mengembangkan keterampilan desain grafis dengan memanfaatkan perangkat lunak desain.",
        "Berkolaborasi dengan tim OSIS dan guru untuk menghasilkan materi visual yang menarik.",
      ],
    },
  ],
  education: [
    {
      school: "SMK Madinatulquran",
      field: "Rekayasa Perangkat Lunak",
      period: "2023 – Sekarang",
      mapUrl: "https://maps.google.com/?q=SMK+Madinatulquran",
    },
    {
      school: "SMPIT Al-Hidayah",
      field: "Middle School",
      period: "2020 – 2023",
      mapUrl: "https://maps.google.com/?q=SMPIT+Al-Hidayah",
    },
  ],

  certificates: [
    {
      id: 1,
      title: "Belajar Dasar Data Science",
      issuer: "Dicoding Indonesia",
      date: "09 Oktober 2024",
      // Sesuai screenshot: file ini menggunakan ekstensi .png
      image: "/assets/images/certificates/DataScience.png", 
      pdfLink: "/assets/images/certificates/DataScience.pdf"
    },
    {
      id: 2,
      title: "Belajar Dasar Structured Query Language (SQL)",
      issuer: "Dicoding Indonesia",
      date: "14 Oktober 2024",
      // Sesuai screenshot: file ini menggunakan ekstensi .png
      image: "/assets/images/certificates/SQL.png",
      pdfLink: "/assets/images/certificates/SQL.pdf"
    },
    {
      id: 3,
      title: "TypeScript Dasar",
      issuer: "Skilvul",
      date: "21 Mei 2024",
      // Sesuai screenshot: Penulisan file 'Typescript.jpg' (s kecil)
      image: "/assets/images/certificates/Typescript.jpg",
      pdfLink: "/assets/images/certificates/Typescript.pdf"
    },
    {
      id: 4,
      title: "React Dasar",
      issuer: "Skilvul",
      date: "13 Mei 2024",
      image: "/assets/images/certificates/React.jpg",
      pdfLink: "/assets/images/certificates/React.pdf"
    },
    {
      id: 5,
      title: "JavaScript Dasar",
      issuer: "Skilvul",
      date: "11 Mei 2024",
      image: "/assets/images/certificates/Javascript.jpg",
      pdfLink: "/assets/images/certificates/Javascript.pdf"
    },
    {
      id: 6,
      title: "HTML Dasar",
      issuer: "Skilvul",
      date: "06 Mei 2024",
      image: "/assets/images/certificates/HTML.jpg",
      pdfLink: "/assets/images/certificates/HTML.pdf"
    },
    {
      id: 7,
      title: "CSS Dasar",
      issuer: "Skilvul",
      date: "06 Mei 2024",
      image: "/assets/images/certificates/CSS.jpg",
      pdfLink: "/assets/images/certificates/CSS.pdf"
    },
    {
      id: 8,
      title: "Honorable Mention - Mini UN Simulation Project",
      issuer: "Class2Class & SMK Madinatulquran",
      date: "17 November 2025",
      image: "/assets/images/certificates/MUNClass2Class.jpg", 
      pdfLink: null // Tidak ada file PDF yang diupload untuk ini, gunakan null atau hapus baris ini
    },
    {
      id: 9,
      title: "Honorable Mention - Internal Simulation MUN",
      issuer: "SMK Madinatulquran (UNICEF Council)",
      date: "27 Mei 2025",
      image: "/assets/images/certificates/MUNInternal.jpg",
      pdfLink: "/assets/images/certificates/MUNInternal.pdf"
    }
  ],

// ... (bagian atas biarkan sama)

  skills: [
    { name: "React", icon: "FaReact", url: "https://react.dev" },
    { name: "TypeScript", icon: "SiTypescript", url: "https://www.typescriptlang.org" },
    { name: "Tailwind CSS", icon: "SiTailwindcss", url: "https://tailwindcss.com" },
    { name: "Laravel", icon: "SiLaravel", url: "https://laravel.com" },
    { name: "PHP", icon: "SiPhp", url: "https://www.php.net" },
    { name: "MySQL", icon: "SiMysql", url: "https://www.mysql.com" },
    { name: "Git", icon: "FaGitAlt", url: "https://git-scm.com" },
    { name: "Figma", icon: "SiFigma", url: "https://www.figma.com" },
    { name: "Postman", icon: "SiPostman", url: "https://www.postman.com" },
    { name: "Vite", icon: "SiVite", url: "https://vitejs.dev" },
    { name: "Next.js", icon: "SiNextdotjs", url: "https://nextjs.org" },
    { name: "NestJS", icon: "SiNestjs", url: "https://nestjs.com" },
    { name: "HTML", icon: "FaHtml5", url: "https://developer.mozilla.org/en-US/docs/Web/HTML" },
    { name: "CSS", icon: "FaCss3Alt", url: "https://developer.mozilla.org/en-US/docs/Web/CSS" },
    { name: "Dart", icon: "SiDart", url: "https://dart.dev" },
    { name: "Flutter", icon: "SiFlutter", url: "https://flutter.dev" },
    { name: "Gemini", icon: "SiGooglegemini", url: "https://ai.google.dev" },
    { name: "Firebase", icon: "SiFirebase", url: "https://firebase.google.com" },
  ],
};
